export const downloadFileUtils = (blob: Blob | File | ArrayBuffer | string, filename: string, mimetype: string) => {
  if ((window as any)?.AppActions?.saveFile) {
    (window as any).AppActions.saveFile(
      blob,
      filename,
      mimetype
    );
  }
}
